"use client";

import { useState } from "react";
import base from "lib/base";
import AuthorModal from "./AuthorModal";
import styles from "styles/components/authors-section.module.css";

const resolveAvatar = (author) => {
  const raw = author?.avatar || "";
  if (!raw) return "";
  if (/^https?:\/\//i.test(raw)) return raw;
  const normalizedCdn = (base.cdnUrl || "").replace(/\/+$/, "");
  const normalizedPath = raw.replace(/^\/+/, "");
  return `${normalizedCdn}/150x150/${normalizedPath}`;
};

const AuthorsSection = ({ authors = [] }) => {
  const items = Array.isArray(authors) ? authors : [];
  const [activeAuthor, setActiveAuthor] = useState(null);

  if (!items.length) {
    return null;
  }

  const renderCard = (author) => {
    const avatar = resolveAvatar(author);
    return (
      <div className={styles.card}>
        <div className={styles.row}>
          {avatar && (
            <img
              src={avatar}
              alt={author?.name || "Author"}
              className={styles.avatar}
            />
          )}
          <div className={styles.texts}>
            <div className={styles.name}>{author?.name || ""}</div>
            <div className={styles.rank}>{author?.title || ""}</div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <section className={`section ${styles.section}`}>
      <div className="container">
        <h3 className={styles.title}>Зохиолчид</h3>

        <div className={styles.desktopList}>
          {items.map((author) => (
            <div
              key={author?._id || author?.name}
              className={styles.desktopItem}
            >
              <button
                type="button"
                className={styles.cardButton}
                onClick={() => setActiveAuthor(author)}
              >
                {renderCard(author)}
              </button>
            </div>
          ))}
        </div>
      </div>

      <AuthorModal
        author={activeAuthor}
        open={!!activeAuthor}
        onClose={() => setActiveAuthor(null)}
      />
    </section>
  );
};

export default AuthorsSection;
